import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getOwnerLocations } from '../../../../api/Practice';

export const usePracticeOwnerLocations = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();

  return useQuery(
    ['practice-owner-locations', ...dependencies],
    () => getOwnerLocations(navigate, params),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      staleTime: 5000,
      ...options
    }
  );
};
